import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeft = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-labelledby="title"
  >
    <title id="title">{ariaLabel}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 5L7 12 15 19"
      />
    </g>
  </svg>
);

ArrowLeft.defaultProps = {
  ariaLabel: '',
};

ArrowLeft.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default ArrowLeft;
